<script setup lang="ts">

import dayjs from "dayjs";
import {Copy, LucideFileDown, Pencil, Trash2} from "@lucide/vue";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger
} from "@/core/components/ui/dropdown-menu";
import {Contest} from "@/contest/interfaces";

defineProps<{contest: Contest}>();
defineEmits(['on-duplication', 'on-edition', 'on-export', 'on-delete']);
</script>

<template>
  <DropdownMenu>
    <DropdownMenuTrigger as-child>
      <slot />
    </DropdownMenuTrigger>
    <DropdownMenuContent align="start">
      <DropdownMenuItem @click.prevent="$emit('on-duplication')">
        <div class="flex flex-row items-center gap-2">
          Dupliquer
          <Copy class="w-4 h-4" />
        </div>
      </DropdownMenuItem>
      <DropdownMenuItem v-if="dayjs(contest.end_date).isAfter(dayjs())" @click.prevent="$emit('on-edition')">
        <div class="flex flex-row items-center gap-2">
          Editer
          <Pencil class="w-4 h-4" />
        </div>
      </DropdownMenuItem>
      <DropdownMenuItem @click="$emit('on-export')">
        Exporter
        <LucideFileDown class="w-4 h-4" />
      </DropdownMenuItem>
      <DropdownMenuItem @click="$emit('on-delete')">
        Supprimer
        <Trash2 class="text-red-500 w-4 h-4" />
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
</template>

<style scoped>

</style>